import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GlobalService } from '../../../../global.service';
import { EventsService } from '../../../events.service';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-orange-ramadan-tournaments',
  templateUrl: './orange-ramadan-tournaments.component.html',
  styleUrls: ['./orange-ramadan-tournaments.component.css']
})
export class OrangeRamadanTournamentsComponent implements OnInit {

  @Input() gameName: 'pubg';
  tournaments = [];
  leaderboards = [];

  constructor(public globalService: GlobalService, public eventService: EventsService, private activeRoute: ActivatedRoute) {


  }

  ngOnInit() {
    this.activeRoute.params.subscribe(param => {
      this.changeRoute(param['code']);
    });
  }

  changeRoute(param) {
    this.eventService.loadEventTournaments = true;
    this.eventService.getEventPlayables('orange-ramadan-cup', 1, 'all', 8).subscribe(res => {
      this.tournaments = res.data.map(function(v){ return {name: v.name, value: v.code}});
      this.eventService.eventTournaments.next(res);
      this.eventService.loadEventTournaments = false;
    }, error => {
      this.eventService.eventTournaments.next({data: []});
      this.eventService.loadEventTournaments = false;
    })
  }

  selectTournament(event){
    let tournamentCode = event.target.value;
    this.eventService.getEventBracket(tournamentCode).subscribe(data => {
      this.leaderboards = data.groups[0].participants.slice(0 , 19);
    })
  }


}
